/**
 * Prompt Category Utilities
 *
 * Centralises the logic that decides which prompt categories are
 * "content-generation" prompts (overridable per business vertical)
 * vs "system/utility" prompts (single copy, not overridable).
 */

const OVERRIDABLE_CATEGORIES = new Set([
  'Source Content',
  'Campaign',
  'Image',
  'Topic Suggestions',
]);

/**
 * Returns true when the category represents a content-generation prompt
 * that should be overridable per vertical / intent.
 *
 * Convention:
 *  - Any category starting with "Content" (Content Blog, Content FAQ, …)
 *  - Plus the explicit set above (Source Content, Campaign, Image, Topic Suggestions)
 *
 * Everything else (AI Command, Utilities, Internal, Agent, Scan Agent,
 * Brand Voice, Persona, Writing Style) is a system/utility prompt.
 */
export const isContentPromptCategory = (category) => {
  if (!category) return false;
  if (category.startsWith('Content')) return true;
  return OVERRIDABLE_CATEGORIES.has(category);
};